module.exports = __webpack_public_path__ + "img/navigation.9b092b0f.svg";